import { createActions } from 'redux-actions';
import { upload, update, request } from '../../services';

const {
  documentsRequest,
  documentsRequestSuccess,
  documentsRequestFailure,
} = createActions({
  DOCUMENTS_REQUEST_SUCCESS: json => json.document_uploads,
}, 'DOCUMENTS_REQUEST', 'DOCUMENTS_REQUEST_FAILURE');

export function fetchPhaseDocuments(phaseId) {
  return (dispatch) => {
    dispatch(documentsRequest());
    return request(`phases/${phaseId}/document_uploads`)
      .then(
        ({ json }) => dispatch(documentsRequestSuccess(json)),
        error => dispatch(documentsRequestFailure(error)),
      );
  };
}

const {
  documentsFilesUpload,
  documentsFilesUploadSuccess,
  documentsFilesUploadFailure,
} = createActions({
  DOCUMENTS_FILES_UPLOAD_SUCCESS: json => json.document_uploads,
}, 'DOCUMENTS_FILES_UPLOAD', 'DOCUMENTS_FILES_UPLOAD_FAILURE');

export function uploadDocument(formData, phaseId) {
  return (dispatch) => {
    dispatch(documentsFilesUpload());
    return upload(formData, `phases/${phaseId}/document_uploads`)
      .then(
        ({ json }) => dispatch(documentsFilesUploadSuccess(json)),
        error => dispatch(documentsFilesUploadFailure(error)),
      );
  };
}

const {
  documentResourceUpdateRequest,
  documentResourceUpdateSuccess,
  documentResourceUpdateFailure,
} = createActions({
  DOCUMENT_RESOURCE_UPDATE_SUCCESS: json => json,
}, 'DOCUMENT_RESOURCE_UPDATE_REQUEST', 'DOCUMENT_RESOURCE_UPDATE_FAILURE');

export function updateDocument(phaseId, document) {
  return (dispatch) => {
    dispatch(documentResourceUpdateRequest());
    return update(`phases/${phaseId}/document_upload`, document, 'document_upload')
      .then(({ json }) => {
        dispatch(documentResourceUpdateSuccess(json));
      },
        error => dispatch(documentResourceUpdateFailure(error)),
      );
  };
}



// WEBPACK FOOTER //
// ./client/app/shared/actionCreators/document_uploads.js